// Single source of truth for external contact links
export const BOOKING_URL = 'https://cal.eu/abdul-rashid-lansah-adam-ccloo9/30min';
export const EMAIL = 'rashidlansahadam@gmail.com';
